// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VillkorRouteImport } from './routes/villkor'
import { Route as Snabblan1000KrRouteImport } from './routes/snabblan-1000-kr'
import { Route as SnabblanRouteImport } from './routes/snabblan'
import { Route as SmslanRouteImport } from './routes/smslan'
import { Route as SmsLan1000KrSwishRouteImport } from './routes/sms-lan-1000-kr-swish'
import { Route as SamlaLanRouteImport } from './routes/samla-lan'
import { Route as ResultatRouteImport } from './routes/resultat'
import { Route as OrdlistaRouteImport } from './routes/ordlista'
import { Route as MikrolanUtanUc1000KrRouteImport } from './routes/mikrolan-utan-uc-1000-kr'
import { Route as LanetestRouteImport } from './routes/lanetest'
import { Route as LanUtanUcRouteImport } from './routes/lan-utan-uc'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as IntegritetspolicyRouteImport } from './routes/integritetspolicy'
import { Route as CookiesRouteImport } from './routes/cookies'
import { Route as BillanRouteImport } from './routes/billan'
import { Route as HubSlugRouteImport } from './routes/$hubSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PrivatlanIndexRouteImport } from './routes/privatlan.index'
import { Route as NyhetIndexRouteImport } from './routes/nyhet.index'
import { Route as BloggIndexRouteImport } from './routes/blogg.index'
import { Route as ServiceSlugRouteImport } from './routes/service.$slug'
import { Route as PrivatlanSlugRouteImport } from './routes/privatlan.$slug'
import { Route as OmOssRedaktionRouteImport } from './routes/om-oss.redaktion'
import { Route as OmOssHurViGranskarRouteImport } from './routes/om-oss.hur-vi-granskar'
import { Route as NyhetSlugRouteImport } from './routes/nyhet.$slug'
import { Route as LpSamlingLanRouteImport } from './routes/lp.samling-lan'
import { Route as LpSamlaLanRouteImport } from './routes/lp.samla-lan'
import { Route as LpLeadsRouteImport } from './routes/lp.leads'
import { Route as LpLanekalkylRouteImport } from './routes/lp.lanekalkyl'
import { Route as LpKonverteringarRouteImport } from './routes/lp.konverteringar'
import { Route as LangivareSlugRouteImport } from './routes/langivare.$slug'
import { Route as LanAmountRouteImport } from './routes/lan.$amount'
import { Route as LanTillPurposeRouteImport } from './routes/lan-till.$purpose'
import { Route as KategoriSlugRouteImport } from './routes/kategori.$slug'
import { Route as GuiderLanekalkylRouteImport } from './routes/guider.lanekalkyl'
import { Route as BloggSlugRouteImport } from './routes/blogg.$slug'
import { Route as BillanModelRouteImport } from './routes/billan_.$model'
import { Route as CategoryAmountRouteImport } from './routes/$category.$amount'

const VillkorRoute = VillkorRouteImport.update({
            id: '/villkor',path: '/villkor',getParentRoute: () => rootRouteImport
          })
const Snabblan1000KrRoute = Snabblan1000KrRouteImport.update({
            id: '/snabblan-1000-kr',path: '/snabblan-1000-kr',getParentRoute: () => rootRouteImport
          })
const SnabblanRoute = SnabblanRouteImport.update({
            id: '/snabblan',path: '/snabblan',getParentRoute: () => rootRouteImport
          })
const SmslanRoute = SmslanRouteImport.update({
            id: '/smslan',path: '/smslan',getParentRoute: () => rootRouteImport
          })
const SmsLan1000KrSwishRoute = SmsLan1000KrSwishRouteImport.update({
            id: '/sms-lan-1000-kr-swish',path: '/sms-lan-1000-kr-swish',getParentRoute: () => rootRouteImport
          })
const SamlaLanRoute = SamlaLanRouteImport.update({
            id: '/samla-lan',path: '/samla-lan',getParentRoute: () => rootRouteImport
          })
const ResultatRoute = ResultatRouteImport.update({
            id: '/resultat',path: '/resultat',getParentRoute: () => rootRouteImport
          })
const OrdlistaRoute = OrdlistaRouteImport.update({
            id: '/ordlista',path: '/ordlista',getParentRoute: () => rootRouteImport
          })
const MikrolanUtanUc1000KrRoute = MikrolanUtanUc1000KrRouteImport.update({
            id: '/mikrolan-utan-uc-1000-kr',path: '/mikrolan-utan-uc-1000-kr',getParentRoute: () => rootRouteImport
          })
const LanetestRoute = LanetestRouteImport.update({
            id: '/lanetest',path: '/lanetest',getParentRoute: () => rootRouteImport
          })
const LanUtanUcRoute = LanUtanUcRouteImport.update({
            id: '/lan-utan-uc',path: '/lan-utan-uc',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const IntegritetspolicyRoute = IntegritetspolicyRouteImport.update({
            id: '/integritetspolicy',path: '/integritetspolicy',getParentRoute: () => rootRouteImport
          })
const CookiesRoute = CookiesRouteImport.update({
            id: '/cookies',path: '/cookies',getParentRoute: () => rootRouteImport
          })
const BillanRoute = BillanRouteImport.update({
            id: '/billan',path: '/billan',getParentRoute: () => rootRouteImport
          })
const HubSlugRoute = HubSlugRouteImport.update({
            id: '/$hubSlug',path: '/$hubSlug',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const PrivatlanIndexRoute = PrivatlanIndexRouteImport.update({
            id: '/privatlan/',path: '/privatlan/',getParentRoute: () => rootRouteImport
          })
const NyhetIndexRoute = NyhetIndexRouteImport.update({
            id: '/nyhet/',path: '/nyhet/',getParentRoute: () => rootRouteImport
          })
const BloggIndexRoute = BloggIndexRouteImport.update({
            id: '/blogg/',path: '/blogg/',getParentRoute: () => rootRouteImport
          })
const ServiceSlugRoute = ServiceSlugRouteImport.update({
            id: '/service/$slug',path: '/service/$slug',getParentRoute: () => rootRouteImport
          })
const PrivatlanSlugRoute = PrivatlanSlugRouteImport.update({
            id: '/privatlan/$slug',path: '/privatlan/$slug',getParentRoute: () => rootRouteImport
          })
const OmOssRedaktionRoute = OmOssRedaktionRouteImport.update({
            id: '/om-oss/redaktion',path: '/om-oss/redaktion',getParentRoute: () => rootRouteImport
          })
const OmOssHurViGranskarRoute = OmOssHurViGranskarRouteImport.update({
            id: '/om-oss/hur-vi-granskar',path: '/om-oss/hur-vi-granskar',getParentRoute: () => rootRouteImport
          })
const NyhetSlugRoute = NyhetSlugRouteImport.update({
            id: '/nyhet/$slug',path: '/nyhet/$slug',getParentRoute: () => rootRouteImport
          })
const LpSamlingLanRoute = LpSamlingLanRouteImport.update({
            id: '/lp/samling-lan',path: '/lp/samling-lan',getParentRoute: () => rootRouteImport
          })
const LpSamlaLanRoute = LpSamlaLanRouteImport.update({
            id: '/lp/samla-lan',path: '/lp/samla-lan',getParentRoute: () => rootRouteImport
          })
const LpLeadsRoute = LpLeadsRouteImport.update({
            id: '/lp/leads',path: '/lp/leads',getParentRoute: () => rootRouteImport
          })
const LpLanekalkylRoute = LpLanekalkylRouteImport.update({
            id: '/lp/lanekalkyl',path: '/lp/lanekalkyl',getParentRoute: () => rootRouteImport
          })
const LpKonverteringarRoute = LpKonverteringarRouteImport.update({
            id: '/lp/konverteringar',path: '/lp/konverteringar',getParentRoute: () => rootRouteImport
          })
const LangivareSlugRoute = LangivareSlugRouteImport.update({
            id: '/langivare/$slug',path: '/langivare/$slug',getParentRoute: () => rootRouteImport
          })
const LanAmountRoute = LanAmountRouteImport.update({
            id: '/lan/$amount',path: '/lan/$amount',getParentRoute: () => rootRouteImport
          })
const LanTillPurposeRoute = LanTillPurposeRouteImport.update({
            id: '/lan-till/$purpose',path: '/lan-till/$purpose',getParentRoute: () => rootRouteImport
          })
const KategoriSlugRoute = KategoriSlugRouteImport.update({
            id: '/kategori/$slug',path: '/kategori/$slug',getParentRoute: () => rootRouteImport
          })
const GuiderLanekalkylRoute = GuiderLanekalkylRouteImport.update({
            id: '/guider/lanekalkyl',path: '/guider/lanekalkyl',getParentRoute: () => rootRouteImport
          })
const BloggSlugRoute = BloggSlugRouteImport.update({
            id: '/blogg/$slug',path: '/blogg/$slug',getParentRoute: () => rootRouteImport
          })
const BillanModelRoute = BillanModelRouteImport.update({
            id: '/billan_/$model',path: '/billan/$model',getParentRoute: () => rootRouteImport
          })
const CategoryAmountRoute = CategoryAmountRouteImport.update({
            id: '/$category/$amount',path: '/$category/$amount',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,HubSlugRoute: HubSlugRoute,BillanRoute: BillanRoute,CookiesRoute: CookiesRoute,IntegritetspolicyRoute: IntegritetspolicyRoute,KontaktRoute: KontaktRoute,LanUtanUcRoute: LanUtanUcRoute,LanetestRoute: LanetestRoute,MikrolanUtanUc1000KrRoute: MikrolanUtanUc1000KrRoute,OrdlistaRoute: OrdlistaRoute,ResultatRoute: ResultatRoute,SamlaLanRoute: SamlaLanRoute,SmsLan1000KrSwishRoute: SmsLan1000KrSwishRoute,SmslanRoute: SmslanRoute,SnabblanRoute: SnabblanRoute,Snabblan1000KrRoute: Snabblan1000KrRoute,VillkorRoute: VillkorRoute,CategoryAmountRoute: CategoryAmountRoute,BillanModelRoute: BillanModelRoute,BloggSlugRoute: BloggSlugRoute,GuiderLanekalkylRoute: GuiderLanekalkylRoute,KategoriSlugRoute: KategoriSlugRoute,LanTillPurposeRoute: LanTillPurposeRoute,LanAmountRoute: LanAmountRoute,LangivareSlugRoute: LangivareSlugRoute,LpKonverteringarRoute: LpKonverteringarRoute,LpLanekalkylRoute: LpLanekalkylRoute,LpLeadsRoute: LpLeadsRoute,LpSamlaLanRoute: LpSamlaLanRoute,LpSamlingLanRoute: LpSamlingLanRoute,NyhetSlugRoute: NyhetSlugRoute,OmOssHurViGranskarRoute: OmOssHurViGranskarRoute,OmOssRedaktionRoute: OmOssRedaktionRoute,PrivatlanSlugRoute: PrivatlanSlugRoute,ServiceSlugRoute: ServiceSlugRoute,BloggIndexRoute: BloggIndexRoute,NyhetIndexRoute: NyhetIndexRoute,PrivatlanIndexRoute: PrivatlanIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)